// @ts-nocheck
import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Default from './Default';
import CookiePolicy from './components/CookiePolicy';
import Maintenance from './components/Maintenance.tsx';
import { BrowserRouter, Routes, Route } from "react-router-dom";
window.jQuery = require("jquery");
export default function LandingPage() {

  return (
      <BrowserRouter>
      <Routes>
      <Route  path="*" element={<Default/>} />
      <Route path="/cookie-policy" element={<CookiePolicy/>} />
      <Route path="/maintenance" element={<Maintenance/>} />
      </Routes>
      </BrowserRouter>


  );
}
